import React from 'react'
import { useHistory, useParams } from 'react-router-dom'

import { Tabs, PageHeader } from 'antd'

import { DollarOutlined, OrderedListOutlined, FolderOpenOutlined } from '@ant-design/icons'

import Details from '../../../../components/job/show/dto/details'
import TasksList from '../../../../components/job/task/list/vendor'
import TaskFinances from '../../../../components/job/task/dto/finance/vendor'

import {
  useFetch,
  useAcceptTask,
  useRejectTask,
  useNegotiateTask,
  useCompleteTask
} from '../../../../hooks/vendor/job'

import { useStorage, isStorageAvailable } from '../../../../hooks/common/storage'

import FileManager from './files'
import Loader from '../../../../components/loader'

const { TabPane } = Tabs

const Show = () => {
  const history = useHistory()
  const onPressBack = () => history.goBack()
  const { id } = useParams()
  const { data, isLoading, isError } = useFetch(id)
  const { data: storageData, isLoading: isStorageLoading, isError: isStorageError } = useStorage()
  const { mutate: acceptTask, isLoading: isAcceptLoading } = useAcceptTask(id)
  const { mutate: rejectTask, isLoading: isRejectLoading } = useRejectTask(id)
  const { mutate: negotiateTask, isLoading: isNegotiateLoading } = useNegotiateTask(id)
  const { mutate: completeTask, isLoading: isCompleteLoading } = useCompleteTask(id)

  const actionLoading = isAcceptLoading || isRejectLoading || isNegotiateLoading || isCompleteLoading

  if (isLoading || isStorageLoading) {
    return (<Loader loading />)
  }
  if (isError || isStorageError) {
    return (<>Error</>)
  }

  const storageAvailable = isStorageAvailable(storageData)

  return (
    <>
      <PageHeader
        ghost={false}
        className='site-page-header'
        onBack={onPressBack}
        title={data.job.display_id}
        subTitle='Job'
        extra={[]}
      >
        <Details forVendor job={data.job} />
      </PageHeader>

      <Tabs
        defaultActiveKey='1'
        type='card'
        style={{ marginBottom: 32, marginTop: 32, backgroundColor: '#fff' }}
      >
        <TabPane
          tab={
            <span>
              {' '}
              <OrderedListOutlined /> Task{' '}
            </span>
          }
          key='tasks'
          style={{ minHeight: 400 }}
        >
          <TasksList
            full
            forVendor
            job={data.job}
            tasks={data.extra?.tasks}
            catlogs
            acceptTask={acceptTask}
            rejectTask={rejectTask}
            negotiateTask={negotiateTask}
            completeTask={completeTask}
            actionLoading={actionLoading}
          />
        </TabPane>
        <TabPane
          tab={
            <span>
              {' '}
              <DollarOutlined /> Finances{' '}
            </span>
          }
          key='finances'
          style={{ minHeight: 400 }}
        >
          <TaskFinances tasks={data.extra?.tasks} />
        </TabPane>

        {storageAvailable && data?.job?.box_public && (
          <TabPane
            tab={
              <span>
                {' '}
                <FolderOpenOutlined /> Files{' '}
              </span>
            }
            key='files'
            style={{ minHeight: 400 }}
          >
            <FileManager
              id={data?.job?.id}
              storage={data?.job?.storage_public}
              defaults={storageData.defaults}
            />
          </TabPane>
        )}
      </Tabs>
    </>
  )
}
export default Show
